export const WORK_ORDERS_QUERY_KEY = 'workorders' as const;

export const workOrderKeys = {
  all: () => [WORK_ORDERS_QUERY_KEY] as const,

  byJobNumber: (jobNumber: string) =>
    [WORK_ORDERS_QUERY_KEY, jobNumber] as const,

  details: (jobNumber: string, allowedEvents?: unknown[]) =>
    [WORK_ORDERS_QUERY_KEY, 'details', jobNumber, allowedEvents] as const,

  detailsUnfiltered: (jobNumber: string) =>
    [WORK_ORDERS_QUERY_KEY, 'detailsUnfiltered', jobNumber] as const,

  charges: (jobNumber: string) =>
    [WORK_ORDERS_QUERY_KEY, 'charges', jobNumber] as const,

  documents: (jobNumber: string) =>
    [WORK_ORDERS_QUERY_KEY, 'documents', jobNumber] as const,

  odata: (params?: Record<string, unknown>) =>
    params
      ? ([WORK_ORDERS_QUERY_KEY, 'odata', params] as const)
      : ([WORK_ORDERS_QUERY_KEY, 'odata'] as const)
} as const;
